import React from "react";
import LoginForm from "./LoginForm";
import SignUpBanner from "./SignUpBanner";
import StayTouch from "../../layout/StayTouch";
import AuthBanner from "../../reusable/AuthBanner";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
class LoginPage extends React.Component {
  render() {
    return (
      <div>
        {/* <AuthBanner title="Get WiFi Anywhere! Anytime!" /> */}
        <LoginForm />
        {/* <SignUpBanner /> */}
        <StayTouch />
      </div>
    );
  }
}

export default layoutWrapper(LoginPage);



// WEBPACK FOOTER //
// ./src/pages/login/index.js